import { USER_TYPE } from "constants/actionAccess";
import { TRANSFER_ORDER_TYPE } from "constants/order";
import { useMyHubsList } from "hooks";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import "./FormHubScanTransferOrder.scss";

const FormHubScanTransferOrder = React.forwardRef((props, ref) => {
  const {
    transferOrderType,
    handleAllowedGroupToTransfer,
    disabled,
    formHook,
    fieldNameHubSend,
    fieldNameHubReceive,
    isForSearchOrderToAdd,
    allowGroupToTranferDefault,
    hubSendDefault,
    hubReceiveDefault,
  } = props;

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields },
    control,
    watch,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
  } = formHook;
  const { data: myHubs, refetch: refetchHubs } = useMyHubsList({
    enabled: true,
  });

  const [isShowBtnSwitch, setIsShowBtnSwitch] = useState(true);
  const [allowedGroupToTransfer, setAllowedGroupToTransfer] = useState(false);

  const [isHubSendFilter, setIsHubSendFilter] = useState(false);
  const [isHubReceiveFilter, setIsHubReceiveFilter] = useState(false);

  const [hubsSendFilter, setHubsSendFilter] = useState([]);
  const [hubsReceiveFilter, setHubsReceiveFilter] = useState([]);

  const [selectedHubSendFilter, setSelectedHubSendFilter] = useState(null);
  const [selectedHubReceiveFilter, setSelectedHubReceiveFilter] =
    useState(null);

  const handleSelectHubSendFilter = hub => {
    formHook && fieldNameHubSend && setValue(fieldNameHubSend, hub);
    setSelectedHubSendFilter(hub);
  };
  const handleSelectHubReceiveFilter = hub => {
    formHook && fieldNameHubReceive && setValue(fieldNameHubReceive, hub);
    setSelectedHubReceiveFilter(hub);
  };

  const setHubSendInfo = hubSendData => {
    if (hubSendData?.length > 0) {
      setHubsSendFilter([...hubSendData]);
      handleSelectHubSendFilter(hubSendData?.[0]);
    }
  };

  const setHubReceiveInfo = hubReceiveData => {
    if (hubReceiveData?.length > 0) {
      setHubsReceiveFilter([...hubReceiveData]);
      handleSelectHubReceiveFilter(hubReceiveData?.[0]);
    }
  };

  const configAllowTransfer = ({ isAllow, isShowBtnSwitch }) => {
    setAllowedGroupToTransfer(isAllow);
    setIsShowBtnSwitch(isShowBtnSwitch);
    if (handleAllowedGroupToTransfer) {
      handleAllowedGroupToTransfer({
        isAllowedGroupToTransfer: isAllow,
        userType: myHubs?.user?.user_type,
      });
    }
  };

  useEffect(() => {
    if (allowGroupToTranferDefault) {
      setAllowedGroupToTransfer(allowGroupToTranferDefault);
    }

    if (hubSendDefault) {
      const hub = hubsSendFilter.find(
        item => item.id === parseInt(hubSendDefault)
      );
      handleSelectHubSendFilter(hub);
    }

    if (hubReceiveDefault) {
      const hub = hubsReceiveFilter.find(
        item => item.id === parseInt(hubReceiveDefault)
      );
      handleSelectHubReceiveFilter(hub);
    }
  }, [allowGroupToTranferDefault, hubSendDefault, hubReceiveDefault]);

  // Set thông tin HUB nơi gửi
  useEffect(() => {
    if (myHubs) {
      const { childs_hub, hub, parent_hub, user } = myHubs;
      if (!hub) {
        return;
      }
      setValue("myHubs", hub);
      const { user_type } = user;
      const { is_center } = hub;
      let allowTransferOrder = allowGroupToTranferDefault
        ? allowGroupToTranferDefault
        : false;
      let isShowBtnSwitch = false;
      //
      switch (transferOrderType) {
        // Đơn trả
        case TRANSFER_ORDER_TYPE.RETURN:
          switch (user_type) {
            // mặc định là quét đơn thường
            case USER_TYPE.LOG_AMDIN:
              allowTransferOrder = false;
              isShowBtnSwitch = true;
              break;
            // mặc định là quét đơn thường (Không cho bật chức năng trung chuyển)
            case USER_TYPE.HUB_ADMIN:
              allowTransferOrder = false;
              isShowBtnSwitch = false;
              break;
            default:
              break;
          }
          break;
        // Đơn nhận
        case TRANSFER_ORDER_TYPE.RECEIVE:
          switch (user_type) {
            // mặc định là quét đơn thường
            case USER_TYPE.LOG_AMDIN:
              allowTransferOrder = false;
              isShowBtnSwitch = true;
              break;
            // mặc định là quét đơn trung chuyển
            case USER_TYPE.HUB_ADMIN:
              allowTransferOrder = true;
              isShowBtnSwitch = true;
              break;
            default:
              break;
          }
          break;
        default:
          break;
      }
      configAllowTransfer({
        isAllow: isForSearchOrderToAdd ? true : allowTransferOrder,
        isShowBtnSwitch: isForSearchOrderToAdd ? false : isShowBtnSwitch,
      });
      // Đơn nhận mẫu
      if (transferOrderType === TRANSFER_ORDER_TYPE?.RECEIVE) {
        // HUB ADMIN
        if (user_type === USER_TYPE.HUB_ADMIN) {
          // From Hub (HUB quản lý)
          setHubSendInfo([hub]);
          // ToCenter (lấy từ parentHub)
          setHubReceiveInfo([parent_hub]);
        } else if (user_type === USER_TYPE.LOG_AMDIN) {
          // LOG ADMIN

          if (isForSearchOrderToAdd) {
            // From Hub lấy từ center/hub của đơn cha
            const idHubSend = getValues("idHubSend");
            const hubSendInfo = childs_hub.find(item => item.id === idHubSend);
            setHubSendInfo([hubSendInfo]);
          } else {
            // From Hub (Select từ list Hub của center)
            setHubSendInfo(childs_hub);
          }

          // To Center (Center quản lý)
          setHubReceiveInfo([hub]);
        }
      }
      // Đơn trả kết quả
      if (transferOrderType === TRANSFER_ORDER_TYPE?.RETURN) {
        // HUB ADMIN
        if (user_type === USER_TYPE.HUB_ADMIN) {
          // From Center (lấy từ parentHub)
          setHubSendInfo([parent_hub]);
          // To Hub (HUB quản lý)
          setHubReceiveInfo([hub]);
        } else if (user_type === USER_TYPE.LOG_AMDIN) {
          // LOG ADMIN
          // From Center (Center quản lý)
          setHubSendInfo([hub]);
          // To Hub (Select từ list Hub của center)

          if (isForSearchOrderToAdd) {
            const hubReceive = getValues("hubReceive");
            const hubReceiveInfo = childs_hub.find(
              item => item.id === hubReceive.value
            );
            setHubReceiveInfo([hubReceiveInfo]);
          } else {
            setHubReceiveInfo(childs_hub);
          }
        }
      }
    }
  }, [myHubs]);

  useEffect(() => {
    refetchHubs();
  }, []);

  React.useImperativeHandle(ref, () => ({
    getMyHub() {
      return myHubs?.hub;
    },
  }));

  return (
    <div className="FormHubScanTransferOrder">
      {/* {myHubs?.user?.user_type === USER_TYPE.LOG_AMDIN && ( */}
      {isShowBtnSwitch && (
        <Button
          className="mb-2 w-100"
          color={allowedGroupToTransfer ? "primary" : "secondary"}
          disabled={disabled}
          type="button"
          onClick={() => {
            configAllowTransfer({
              isAllow: !allowedGroupToTransfer,
              isShowBtnSwitch: true,
            });
          }}
        >
          {"Đơn trung chuyển"}
        </Button>
      )}

      {/* )} */}
      {allowedGroupToTransfer && (
        <div className="d-flex gap-2">
          {/* Hub Send Info */}
          {!selectedHubSendFilter ? (
            <div
              className="d-flex gap-1 align-items-center text-warning fw-bold"
              style={{
                fontSize: "14px",
                marginTop: "-6px",
                fontStyle: "italic",
              }}
            >
              {"("}
              <i className="bx bx-error" />
              <div>Chưa cấu hình nơi gửi</div>
              {")"}
            </div>
          ) : (
            <Dropdown
              disabled={
                myHubs?.user?.user_type === USER_TYPE.HUB_ADMIN || disabled
              }
              isOpen={isHubSendFilter}
              toggle={() => setIsHubSendFilter(!isHubSendFilter)}
            >
              <DropdownToggle
                className={`btn ${
                  disabled ? "secondary" : "primary"
                }-btn w-100`}
                caret
              >
                {/* {transferOrderType === TRANSFER_ORDER_TYPE.RECEIVE
            ? "Hub gửi"
            : "Center gửi"} */}
                {selectedHubSendFilter && (
                  <span>&nbsp;{selectedHubSendFilter?.name}</span>
                )}
                <i className="mdi mdi-chevron-down" />
              </DropdownToggle>
              <DropdownMenu className="w-100">
                {hubsSendFilter?.map((hub, index) => (
                  <DropdownItem
                    key={`hub-${index}`}
                    onClick={() => handleSelectHubSendFilter(hub)}
                  >
                    {hub?.name}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          )}

          <div
            className="d-flex justify-content-center"
            style={{ marginTop: "-4px" }}
          >
            <i
              style={{
                fontSize: "30px",
              }}
              className={"text-info mdi mdi-ray-start-arrow"}
            />
          </div>
          {/* Hub Receive Info */}
          {!selectedHubReceiveFilter ? (
            <div
              className="d-flex gap-1 align-items-center text-warning fw-bold"
              style={{
                fontSize: "14px",
                marginTop: "-6px",
                fontStyle: "italic",
              }}
            >
              {"("}
              <i className="bx bx-error" />
              <div>Chưa cấu hình nơi nhận</div>
              {")"}
            </div>
          ) : (
            <Dropdown
              disabled={
                myHubs?.user?.user_type === USER_TYPE.HUB_ADMIN || disabled
              }
              isOpen={isHubReceiveFilter}
              toggle={() => setIsHubReceiveFilter(!isHubReceiveFilter)}
            >
              <DropdownToggle
                className={`btn ${
                  disabled ? "secondary" : "primary"
                }-btn w-100`}
                caret
              >
                {/* {transferOrderType === TRANSFER_ORDER_TYPE.RECEIVE
          ? "Center nhận"
          : "Hub nhận"} */}
                {selectedHubReceiveFilter && (
                  <span>&nbsp;{selectedHubReceiveFilter?.name}</span>
                )}
                <i className="mdi mdi-chevron-down" />
              </DropdownToggle>
              <DropdownMenu className="w-100">
                {hubsReceiveFilter?.map((hub, index) => (
                  <DropdownItem
                    key={`hub-${index}`}
                    onClick={() => handleSelectHubReceiveFilter(hub)}
                  >
                    {hub?.name}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          )}
        </div>
      )}
    </div>
  );
});

FormHubScanTransferOrder.propTypes = {
  disabled: PropTypes.bool,
  transferOrderType: PropTypes.any.isRequired,
  handleAllowedGroupToTransfer: PropTypes.any.isRequired,
};

export default FormHubScanTransferOrder;
